import Image from "next/image";
import Link from "next/link";
import { useEffect , useState } from "react";

import TeamData from "../../data/elements/team.json";
import { getAllInstructors } from "@/services/instructorApi";

const TeamTwo = () => {

  const [instructor , setInstructor] = useState([])

const fetchdetails = async () => {
  try {
    const data = await getAllInstructors();

    
    // Set the first instructor as active by default
    const instructorData = data.data.slice().reverse().map((item, index) => ({
      ...item,
      isActive: index === 0 // Set first item as active
    }));
    
    setInstructor(instructorData);
  } catch (err) {
    console.log("Error in fetching", err);
  }
};


  useEffect(() => {
    fetchdetails()
  }, [])
  
  return (
    <>
      <div className="row g-5">
        <div className="col-lg-7">
          <div className="rbt-team-tab-content tab-content" id="myTabContent">
            {instructor &&
              instructor.map((data, index) => (
                <div
                  className={`tab-pane fade ${index === 0 ? "active show" : ""}`}
                  id={`team-tab${index}`}
                  role="tabpanel"
                  aria-labelledby={`team-tab${index}-tab`}
                  key={index}
                >

      <div className="inner" key={index}>
        <div className="rbt-team-thumbnail">
          <div className="thumb">
            <Image
              src={data.photoUrl || "/images/instructor/instructor2.jpg"}  
          
              width={415}
              height={555}
              priority
              alt="Testimonial Images"
            />
          </div>

        </div>
        <div className="rbt-team-details">
          <div className="author-info">
           <h4 className="title">
{data?.firstName && data.firstName.trim() !== ""
  ? data.firstName.charAt(0).toUpperCase() + data.firstName.slice(1)
  : data?.Name
  ? data.Name.charAt(0).toUpperCase() + data.Name.slice(1)
  : ""}

          </h4>



            <span className="designation theme-gradient">{data?.role.charAt(0).toUpperCase() + data.role.slice(1)}</span>
            <span className="team-form">
              {/* <i className="feather-map-pin"></i> */}
              {/* Uncomment if location available */}
              {/* <span className="location">{data.location}</span> */}
            </span>
          </div>
          <p>{data.bio}</p>
          <ul className="social-icon social-default mt--20 justify-content-start">
            <li>
              <Link href="https://www.facebook.com/">
                <i className="feather-facebook"></i>
              </Link>
            </li>
            <li>
              <Link href="https://www.twitter.com">
                <i className="feather-twitter"></i>
              </Link>
            </li>
            <li>
              <Link href="https://www.instagram.com/">
                <i className="feather-instagram"></i>
              </Link>
            </li>
          </ul>
          <ul className="rbt-information-list mt--25">
            <li>
              <Link href="#">
                <i className="feather-phone"></i>
                {data.phoneNumber}
              </Link>
            </li>
            <li>
              <Link href={`mailto:${data.email}`}>
                <i className="feather-mail"></i>
                {data.email}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  ))}

            <div className="top-circle-shape"></div>
          </div>
        </div>

        <div className="col-lg-5">
          <ul
            className="rbt-team-tab-thumb nav nav-tabs"
            id="myTab"
            role="tablist"
          >
            {instructor &&
              instructor.slice(0, 6).map((data, index) => (
                <li key={index}>
                  <Link
                    className={`${index === 0 ? "active" : ""}`}
                    id={`team-tab${index}-tab`}
                    data-bs-toggle="tab"
                    data-bs-target={`#team-tab${index}`}
                    role="tab"
                    aria-controls={`team-tab${index}`}
                    aria-selected={index === 0}
                    href="#"
                  >
                    <div className="rbt-team-thumbnail">
                      <div className="thumb">
                        <Image
                          src={
                              data?.photoUrl
                                ? data.photoUrl
                                : data?.gender === "male"
                                ? "/images/instructor/instructor2.jpg"
                                : "/images/instructor/instructor1.jpg"
                            }
                            width={415}
                            height={555}
                            priority
                            alt={data?.userName || "Instructor"}
                        />
                      </div>
                    </div>
                  </Link>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default TeamTwo;
